import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyBootModule } from 'owa-bundling-light';

const lazyBootModule: LazyBootModule<typeof lazyIndex> = new LazyBootModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "StartAccountData" */ './lazyIndex'),
    { name: 'StartAccountData' }
);

export const lazyGetStartAccountData: LazyAction<
    typeof lazyIndex.getStartAccountData,
    typeof lazyBootModule
> = new LazyAction(lazyBootModule, m => m.getStartAccountData);
export const lazySetStartAccountDataOverride: LazyAction<
    typeof lazyIndex.setStartAccountDataOverride,
    typeof lazyBootModule
> = new LazyAction(lazyBootModule, m => m.setStartAccountDataOverride);

export type { GetStartAccountDataOverride } from './GetStartAccountDataOverride';
